module.exports = __webpack_public_path__ + "8684f536ffa6a06a291739a7fb7406a6.jpg";